/**
 * Recebe um numero formatado em string e retorna em float: Ex: 1.400,15 se torna 1400.15
 * @param n
 * @param decimals
 * @returns
 */
export const numeroToNumber = function (n, decimals = 2) {
    if (typeof n !== "string") {
        return 0.0;
    }
    var num = n
        .replace(/[^0-9\.,\-]/g, "")
        .replace(/\./g, "")
        .replace(",", ".");
    if (n)
        num = Number(num).toFixed(decimals);
    return Number(num);
};
export const moneyToReais = (money) => {
    return numberToNumero(money, "R$ ");
};
/**
 * Number.prototype.format(n, x, s, c)
 *
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
const format = function (myNumber, n, x, s, c) {
    var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")", num = myNumber.toFixed(Math.max(0, ~~n));
    return (c ? num.replace(".", c) : num).replace(new RegExp(re, "g"), "$&" + (s || ","));
};
/**
 * Recebe um float e retorna formatado: Ex: 1400.15 se torna 1.400,15
 * @param n
 * @param decimals
 * @returns
 */
export const numberToNumero = function (myNumber, prefixo = "") {
    return prefixo + format(myNumber, 2, 3, ".", ",");
};
/**
 * Remove todos os acentos e caracteres especiais de uma string
 * @param str
 * @returns
 */
export const removeAccents = (str = "") => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
export const isValidDateBr = function (data) {
    if (!data) {
        return false;
    }
    const matches = /^(\d{2})[-\/](\d{2})[-\/](\d{4})$/.exec(data.substring(0, 10));
    if (matches == null)
        return false;
    const d = Number(matches[1]);
    const m = Number(matches[2]) - 1;
    const y = Number(matches[3]);
    const composedDate = new Date(y, m, d);
    const isValid = composedDate.getDate() == d &&
        composedDate.getMonth() == m &&
        composedDate.getFullYear() == y;
    if (!isValid) {
        console.warn("[isValidDateBr] Data inválida: " + data);
    }
    return isValid;
};
export const dataBr2Iso = (str = "") => {
    if (isValidDateBr(str)) {
        const data = str.split("/").reverse().join("-");
        return data;
    }
    return "";
};
export const dataIso2Br = (str = "") => {
    const data = str.split("-").reverse().join("/");
    return data;
};
export const dataHoraBr2Iso = (str = "") => {
    if (isValidDateBr(str)) {
        const dataHora = str.split(" ");
        const data = dataHora[0].split("/").reverse().join("-");
        const hora = dataHora[1];
        return data + " " + hora;
    }
    return "";
};
export const dataHoraIso2Br = (str = "") => {
    const dataHora = str.split(" ");
    const data = dataHora[0].split("-").reverse().join("/");
    const hora = dataHora[1];
    return data + " " + hora;
};
function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        console.log("Fallback: Copying text command was " + msg);
    }
    catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
    }
    document.body.removeChild(textArea);
}
export function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        console.log("Async: Copying to clipboard was successful!");
    }, function (err) {
        console.error("Async: Could not copy text: ", err);
    });
}
export async function getBase64(file) {
    const p = new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            resolve(reader.result);
        };
        reader.onerror = function (error) {
            reject(error);
        };
    });
    const b64 = (await p);
    return b64;
}
export const nl2br = (str = "") => {
    return str.replace(/\n/g, "<br />");
};
export function converteData(data) {
    if (!data)
        return data;
    var parts = data.match(/(\d+)/g);
    if (!parts[2]) {
        console.log("String inválida para conversão de data!");
        return "";
    }
    if (parts[2].length === 4) {
        //data em formato dd/mm/yyyy
        return parts[2] + "-" + parts[1] + "-" + parts[0];
    }
    else if (parts[0].length === 4) {
        //data em formato yyyy-mm-dd
        return parts[2] + "/" + parts[1] + "/" + parts[0];
    }
    else {
        console.log("String inválida para conversão de data.");
    }
}
export function intlNumber2Currency(n) {
    const locale = document.querySelector("html")?.getAttribute("lang")?.replace("_", "-") ??
        "pt_BR";
    const currencyCode = document
        .querySelector("meta[name=locale-currency-code]")
        ?.getAttribute("content") ?? "BRL";
    const obj = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currencyCode,
    }).format(n);
    let output = obj.toString();
    if (n < 0) {
        const prefix = n
            .toLocaleString(locale, {
            style: "currency",
            currency: currencyCode,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        })
            .replace(/\d/g, "")
            .trim();
        const positivePrefix = intlGetCurrencySymbol();
        output = positivePrefix + " -" + output.replace(/[^0-9\.\,]/g, "");
    }
    return output;
}
export function intlGetCurrencySymbol() {
    const locale = document.querySelector("html")?.getAttribute("lang")?.replace("_", "-") ??
        "pt_BR";
    const currency = document
        .querySelector("meta[name=locale-currency-code]")
        ?.getAttribute("content") ?? "BRL";
    return (0)
        .toLocaleString(locale, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })
        .replace(/\d/g, "")
        .trim();
}
export function converteDataHora(data) {
    if (!data)
        return data;
    var parts = data.match(/(\d+)/g);
    if (!parts[3] || !parts[4]) {
        console.log("String inválida para conversão de data/hora!");
        return "";
    }
    if (parts[2].length === 4) {
        //data em formato dd/mm/yyyy
        return (parts[2] +
            "-" +
            parts[1] +
            "-" +
            parts[0] +
            " " +
            parts[3] +
            ":" +
            parts[4]);
    }
    else if (parts[0].length === 4) {
        //data em formato yyyy-mm-dd
        return (parts[2] +
            "/" +
            parts[1] +
            "/" +
            parts[0] +
            " " +
            parts[3] +
            ":" +
            parts[4]);
    }
    else {
        console.log("String inválida para conversão de data/hora.");
    }
}
export default {};
